"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Widget", {
    enumerable: true,
    get: function() {
        return _Widget.Widget;
    }
});
const _Widget = require("./Widget");

//# sourceMappingURL=index.js.map